import React from 'react';

interface ButtonGroupOption<T> {
  value: T;
  label: string;
}

interface ButtonGroupProps<T> {
  label?: string;
  options: ButtonGroupOption<T>[];
  value: T | null | undefined;
  onChange: (value: T) => void;
  name?: string;
  className?: string;
  disabled?: boolean;
}

export function ButtonGroup<T extends string | number | boolean>({
  label,
  options,
  value,
  onChange,
  name,
  className = '',
  disabled = false,
}: ButtonGroupProps<T>) {
  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-sm font-medium text-gray-700">{label}</label>
      )}
      <div className={`inline-flex rounded-lg shadow-xs ${className}`}>
        {options.map((option, index) => (
          <button
            key={index}
            type="button"
            className={`
              cursor-pointer relative inline-flex items-center px-4 py-2 font-medium
              ${index === 0 ? 'rounded-l-lg' : ''}
              ${index === options.length - 1 ? 'rounded-r-lg' : ''}
              ${option.value === value
                ? 'z-10 bg-gradient-to-tr from-blue-600 to-blue-400 text-white'
                : 'bg-white text-gray-700 hover:bg-gray-100'
              }
              ${index !== 0 ? '-ml-px' : ''}
              border border-gray-300 focus:z-10 focus:outline-hidden focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500
            `}
            onClick={() => onChange(option.value)}
            aria-current={option.value === value ? 'page' : undefined}
            name={name}
            disabled={disabled}
          >
            {option.label}
          </button>
        ))}
      </div>
    </div>
  );
} 